module.exports = __webpack_public_path__ + "img/cube.f40a7d3e.svg";